import { graphql } from "../generated";

export const ANIMATION_PAGE = graphql(`
  query GetAnimation($slug: String!) {
    animation(slug: $slug) {
      ...AnimationListItemFields
      userId
      dateCreated
      dateUpdated
      sequence
      views
      blacklisted
      public
      width
      height
      frames
      format
      user {
        ...CoreUserFields
      }
      reactionsBreakdown {
        id
        type
        user {
          id
          name
          avatarUrl
          theme {
            username
          }
        }
      }
      olderAnimations {
        id
        title
        userId
        version
        url
        pixelMode
        type
        reactions {
          love
          laugh
          dizzy
          stars
        }
        commentCount
        encoded
        schemaVersion
        thumbFormat
      }
      thread {
        id
        userId
        title
        type
        createdAt
        updatedAt
        endDate
        locked
        pinned
        voteSummary {
          id
          userVotes
          animationVotes {
            animationId
            votes
          }
        }
        posts {
          ...PostsFields
        }
      }
    }
  }
`);
